const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="hero-banner">
        <h1>Boundless Adventures</h1>
        <p>
          Explore the world's wonders, create unforgettable memories, and unlock
          new adventures with us.
        </p>
        <a href="#tours" className="btn hero-btn">
          explore tours
        </a>
      </div>
    </section>
  )
}
export default Hero
